import React, { useState } from 'react'
import { useNavigate } from 'react-router';
import { formatDate } from '../../helper/formatDate';
import { useTranslate } from '../TranslationText';
import CustomPopUp from '../CustomPopUp';
import EahsForm from '../EahsForm';
import { addedithorsequalification, deleteShowEntry, getCountries, gethorsequalificationbyhorseid } from '../../pages/showEntry/apis/CreateShowEntry';
import { isValidUrl } from '../../helper/validateURL';
import { eformInput } from '../../common/cssclasses';
import NetaqInput from '../NetaqInput';
import { isEmpty } from '../../helper/validaiteInputs';

const BaseURL = process.env.REACT_APP_BASE_URL;
export default function ShowEntryHorseCard({ horse, onClick, isSelectedTab = false, showId, showDetails = {}, toast }) {
    const navigate = useNavigate();
    const { translate } = useTranslate();
    const [countriesData, setCountriesData] = useState([]);
    const isInternationalHorse = ((horse?.status?.toLowerCase() == 'returned' || (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isRegisterd && !horse?.isEarlyYearlingHorse))
    const isFoalHorse = ((horse?.status?.toLowerCase() == 'returned' || (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isRegisterd && !!horse?.isEarlyYearlingHorse))
    const [isSending, setIsSending] = useState(false);
    const handleQualificationChange = (e) => {
        setQualificationObj({
            ...qualificationObj,
            [e.target.name]: e.target.value
        })
    };

    const qualObj = {
        CountryId: '',
        ShowName: '',
        Year: '',
        Class: '',
        Rank: ''
    }
    const [qualificationObj, setQualificationObj] = useState(qualObj)


    function submitQuilifications() {
        const theField = `${translate('web.theField', 'The Field')} `;
        const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;
        if (isEmpty(qualificationObj.CountryId)) {
            toast.error(theField + translate('web.countryName', 'countryName') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.ShowName)) {
            toast.error(theField + translate('web.showName', 'showName') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Year)) {
            toast.error(theField + translate('web.Year', 'Year') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Class)) {
            toast.error(theField + translate('web.className', 'className') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Rank)) {
            toast.error(theField + translate('web.Rank', 'Rank') + isrequired);
            return false;
        }
        if (!!qualificationObj?.websiteURL ?? false) {
            if (!isValidUrl(qualificationObj?.websiteURL)) {
                toast.error(theField + translate('web.urlNotValid', 'websiteURL'));
                return false;
            }
        }
        setIsSending(true);
        const obj = {
            id: horse?.id,
            countryId: qualificationObj.CountryId,
            showName: qualificationObj.ShowName,
            year: new Date (qualificationObj.Year),
            className: qualificationObj.Class,
            classRank: qualificationObj.Rank,
            website: qualificationObj?.websiteURL ?? '',
        }
        addedithorsequalification(obj).then((res) => {
            if (!!res) {
                setIsSending(false);
                {
                    toast.success(translate('web.qualificationsAddedSuccessfully', 'QualificationsAddedSuccessfully'))
                    setQualificationObj(qualObj)
                    onClick();
                }
            }else{
                toast.error(translate('web.errorInAddingQualification', 'errorInAddingQualification'))
            }
        })
    }

    function deleteHorse() {
        if (horse?.showHorseId) {
            deleteShowEntry(horse?.showHorseId).then((res) => {
                if (res) {
                    toast.success(translate('web.horseDeletedSuccessfully', 'Horse Deleted Successfully'))
                    onClick();
                } else {
                    toast.error(translate('web.horseDeletedFaild', 'Horse Deleted Faild'))
                }
            })

        } else {
            onClick()
        }
    }


    function onOpenPopUp() {
        getCountries().then((res) => {
            if (res.length <= 0) {
                toast.error(translate('web.erroringettingcountries', 'Error In getting Countries'))
                return;
            } else {
                setCountriesData(res);
            }
        });
        gethorsequalificationbyhorseid(horse?.id).then((res) => {
            debugger
            const obg = {
                Class: res?.className,
                CountryId: res?.countryId,
                Rank: res?.classRank?.toString(),
                ShowName: res?.showName,
                Year: formatDate(res?.year, true, true)
            }
            setQualificationObj(obg);
        })
    }

    return (
        <div className={'hourseCardClass bg-white p-main border-15 p-3 mb-main'} style={{ minHeight: "unset" }}>
            <div className='w-100 fw-bold' >
                <i className=" fa-solid fa-chess-knight C89C66" />{horse?.regNr} - {horse?.name}
            </div>
            <div className='w-100' ><i className=" fa fa-calendar C89C66" />{formatDate(horse?.birthDate)}</div>
            {!!horse?.ownerName &&
                <div className='w-100' ><i className=" fa fa-user C89C66" />{horse?.ownerName}</div>
            }
            <div className='w-100' ><i className=" fa fa-globe-americas C89C66" />{horse?.origin}</div>
            {horse?.categoryName &&
                <div className='w-100' ><i className=" fa fa-tags C89C66" />{horse?.categoryName}</div>
            }
            {!horse?.isQualified &&
                <div className='w-100' ><i className=" fa fa-ban C89C66" />{translate('web.notqualified', 'Not qualified')} {horse?.notEligibleReason}</div>
            }
            {horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && horse?.isQualified && !isInternationalHorse &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addHorse', 'Add')} onClick={onClick} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
            }
            {isInternationalHorse &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addHorse', 'Add')} onClick={() => navigate(`/addInternationalHorse?isEdit=true&horseId=${horse.id}&showId=${showId}&showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
            }
            {horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isQualified && !isFoalHorse &&
                <CustomPopUp
                    trigger={
                        <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addQualifications', 'Add Qualifications')} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
                    }
                    title={translate("web.horsequalifications", "Horse Qualifications") + " " + `${horse?.regNr} - ${horse?.name}`}
                    onOpen={() => {
                        onOpenPopUp()
                    }}
                    content={
                        <EahsForm className='mb-main' >
                            <div className={eformInput}>
                                <NetaqInput
                                    type='select'
                                    label={translate("web.countryName", "Country Name")}
                                    required
                                    value={countriesData.find((item) => item.value == qualificationObj?.CountryId)}
                                    onChange={(selectedItem) => setQualificationObj((prev) => ({ ...prev, CountryId: selectedItem?.value }))}
                                    placeholder={translate("web.countryName", "Country Name")}
                                    name={"countryQual"}
                                    listSelect={countriesData}
                                    disabled={qualificationObj?.noRequiredQualifications}

                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.showName", "Show Name")}
                                    name={"ShowName"}
                                    placeholder={translate("web.showName", "Show Name")}
                                    type={"text"}
                                    onChange={handleQualificationChange}
                                    value={qualificationObj?.ShowName}
                                    required={true}
                                    disabled={qualificationObj?.noRequiredQualifications}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    name={"Year"}
                                    type={"normalDate"}
                                    label={translate("web.year", "Year")}
                                    onChange={handleQualificationChange}
                                    value={qualificationObj?.Year}
                                    required={true}
                                    disabled={qualificationObj?.noRequiredQualifications}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.className", "Class Name")}
                                    name={"Class"}
                                    placeholder={translate("web.className", "Class Name")}
                                    type={"text"}
                                    onChange={handleQualificationChange}
                                    value={qualificationObj?.Class}
                                    required={true}
                                    disabled={qualificationObj?.noRequiredQualifications}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    type='number'
                                    name="Rank"
                                    label={translate("web.classRank", "Class Rank")}
                                    required
                                    min="1"
                                    step="1"
                                    onChange={handleQualificationChange}
                                    value={qualificationObj?.Rank}
                                    disabled={qualificationObj?.noRequiredQualifications}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.referenceWebsiteURL",
                                        "Reference Website URL"
                                    )}
                                    name={"websiteURL"}
                                    placeholder={translate("web.websiteURL", "Website URL")}
                                    type={"text"}
                                    onChange={handleQualificationChange}
                                    value={qualificationObj?.websiteURL}
                                    disabled={qualificationObj?.noRequiredQualifications}
                                />
                                {qualificationObj?.websiteURL && (!isValidUrl(qualificationObj?.websiteURL)) &&
                                    <span className={`text-danger`}>
                                        {translate("web.urlNotValid", "URL not valid")}
                                    </span>
                                }
                            </div>
                        </EahsForm>
                    }
                    onClick={submitQuilifications}
                />
            }
            {isSelectedTab && showDetails?.isInternationalShow && isInternationalHorse &&
                <div className='position-absolute bottom-0 end-0 mb-3 me-3' style={{ cursor: 'pointer' }} onClick={() => navigate(`/addInternationalHorse?isEdit=true&horseId=${horse.id}&showId=${showId}&showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)}>
                    <i className=" fa C89C66 fa-edit "></i>
                </div>
            }
            {showDetails?.isEarlyYearling && isFoalHorse &&
                <div className='position-absolute bottom-0 end-0 mb-3 me-3' style={{ cursor: 'pointer' }} onClick={() => navigate(`/addEarlyYearlingHorse?isEdit=true&horseId=${horse?.id}&showId=${showId}&${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)} >
                    <i className=" fa C89C66 fa-edit "></i>
                </div>
            }
            {isSelectedTab && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' style={{ cursor: 'pointer' }} onClick={() => { deleteHorse() }} >
                    <i className="fa C89C66 fa-trash"></i>
                </div>
            }
        </div>
    )
}
